var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-row', {
    class: _vm.className,
    attrs: {
      "no-gutters": "",
      "align": "center"
    }
  }, [_vm._l(_vm.items, function (_ref, index) {
    var key = _ref.key,
        props = _ref.props,
        _ref$props_col = _ref.props_col,
        props_col = _ref$props_col === void 0 ? {} : _ref$props_col;
    return [index ? _c('v-col', {
      key: "".concat(key, "-divider"),
      staticClass: "px-8",
      attrs: {
        "cols": "auto"
      }
    }, [_vm._v(" - ")]) : _vm._e(), _c('v-col', _vm._b({
      key: key
    }, 'v-col', props_col, false), [_c('v-select', _vm._b({
      on: {
        "input": _vm.emit
      },
      model: {
        value: _vm.$data[key],
        callback: function callback($$v) {
          _vm.$set(_vm.$data, key, $$v);
        },
        expression: "$data[key]"
      }
    }, 'v-select', Object.assign({}, _vm.$attrs, props, {
      disabled: !!index && !_vm.$data[_vm.items[index - 1].key],
      appendIcon: null
    }), false))], 1)];
  })], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }